import {Select2} from "../Select2";
import {countries} from "../../DataSource/countries";

export const Country = {
    name: 'Country',
    props: ['value', 'onlyEU', 'onlySendFrom', 'settings'],
    components: {
        Select2
    },
    data() {
        return {
            countries: []
        }
    },
    mounted() {
        countries(this.onlyEU, this.onlySendFrom)
            .then(result => {
                this.countries = result;
            });
    },
    methods: {
        hasCountry(code) {
            if (!code) {
                return false;
            }
            return !!this.countries.find(country => country.id === code);
        }
    },
    watch: {
        value(newValue) {
            if (!this.hasCountry(newValue)) {
                this.$emit('input', undefined);
            }
        }
    },
    template: `
        <Select2 :options="countries" v-bind="$attrs" :value="value" v-on="$listeners" :settings="settings"/>
    `
};